var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.49967 0.0859375C2.52051 0.0859375 0.0830078 2.52344 0.0830078 5.5026C0.0830078 8.48177 2.52051 10.9193 5.49967 10.9193C8.47884 10.9193 10.9163 8.48177 10.9163 5.5026C10.9163 2.52344 8.47884 0.0859375 5.49967 0.0859375ZM5.49984 9.83724C3.1165 9.83724 1.1665 7.88724 1.1665 5.50391C1.1665 3.12057 3.1165 1.17057 5.49984 1.17057C7.88317 1.17057 9.83317 3.12057 9.83317 5.50391C9.83317 7.88724 7.88317 9.83724 5.49984 9.83724ZM4.68717 3.33529H3.87467V6.58529L6.69134 8.31862L7.12467 7.61445L4.68717 6.15195V3.33529Z",
    fill: "#939393",
    fillOpacity: 0.9
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.4650121d7c8fae6c3361daa466be27b1.svg";
export { ForwardRef as ReactComponent };